import { LoaderFunction, NonIndexRouteObject } from "react-router-dom";
import { Api } from "../api/api";
import { ErrorElement } from "../components/error-element/ErrorElement";
import { createApolloLoader } from "../helpers/create-apollo-loader";
import { getSsoClient } from "../helpers/get-sso-client";
import { errorText } from "../statics/error-text";
import { App } from "./App";
import { APP_LAYOUT_ID, AppLayoutConfig } from "./App.Parts";

// LOADER
const AppLoader = (config: AppLayoutConfig): LoaderFunction => {
  const { appId, coreBackendUrl, ssoFrontendUrl } = config;
  return (args, ctx) => {
    // Set the app ID header for API requests
    Api.defaults.headers.common["x-app-id"] = appId;

    // Initialize the SSO client...
    getSsoClient(appId, coreBackendUrl, ssoFrontendUrl);

    // Run the Apollo loader...
    const apolloLoader = createApolloLoader(config);
    apolloLoader(args, ctx);
  };
};

// WRAPPER

// LAYOUT
export const AppLayout = (
  config: AppLayoutConfig,
  /** @todo - try LayoutRoutesProps return type when app routing is more stable */
): NonIndexRouteObject => ({
  id: APP_LAYOUT_ID,
  errorElement: <ErrorElement errorText={errorText} />,
  element: <App config={config} />,
  loader: AppLoader(config),
});
